import type { RouteLocationRaw } from 'vue-router'
import * as Sentry from '@sentry/nuxt'

export default function useAuth() {
  const account = useState<components['schemas']['Account'] | null>(
    'auth_account',
    () => null
  )
  const collaborator = useState<components['schemas']['Collaborator'] | null>(
    'auth_collaborator',
    () => null
  )
  const isAuthenticated = computed<boolean>(() => !!account.value)

  const logout = async (to?: RouteLocationRaw) => {
    const { $api, $umami } = useNuxtApp()
    await $api('token/delete/', {
      method: 'POST',
    }).then(() => {
      account.value = null

      Sentry.setUser(null)
      $umami.identify()

      navigateTo(to ?? { name: 'account-login' })
    })
  }

  const setAccount = async () => {
    const { $api, $umami } = useNuxtApp()
    await $api<components['schemas']['Account']>('/account/')
      .then((response) => {
        account.value = response

        const userPayload = {
          id: response.id,
          email: response.email,
          username: response.email,
        }

        Sentry.setUser(userPayload)
        $umami.identify(userPayload)
      })
      .catch(() => (account.value = null))
  }

  const setCollaborator = async () => {
    const { $api } = useNuxtApp()
    await $api<components['schemas']['Collaborator']>('/collaborator/')
      .then((response) => (collaborator.value = response))
      .catch(() => (collaborator.value = null))
  }

  return {
    account,
    collaborator,
    isAuthenticated,
    logout,
    setAccount,
    setCollaborator,
  }
}
